export function isSocialEnabledForStoreView(portal, location) {
  return !!portal?.bundle_social_enabled && !!location?.social_publishing_enabled
}

export function hasConnectedSocialPlatforms(connection) {
  return (connection?.social_connection_platforms || []).some(row => row?.status === 'connected')
}

/** Social Accounts nav: enabled settings OR any connected platform. */
export function shouldShowSocialAccounts(portal, location, connection) {
  return isSocialEnabledForStoreView(portal, location) || hasConnectedSocialPlatforms(connection)
}

/** Social Posts history nav: any posts for this user on the portal, regardless of settings. */
export function shouldShowSocialPosts(socialPostsTotal) {
  return (socialPostsTotal || 0) > 0
}
